import styled from "styled-components";

export const StyledInput = styled.input`
  width: 100%;
  border: 1px solid #c4c4c4;
  border-radius: 15px;
  padding: 5px 10px;
  margin-bottom: 10px;
  margin-top: 10px;

  &::placeholder {
    font-size: 0.8rem;
    color: rgba(0, 0, 0, 0.6);
  }

  @media (max-width: 899px) {
    padding: 10px 15px;

    &::placeholder {
      font-size: 0.9rem;
      color: rgba(0, 0, 0, 0.6);
    }
  }
`